import { Avatar, Dropdown, Flex, Space, Typography } from 'antd';
import type { MenuProps } from 'antd';

import { LanguageSwitcherContainer } from '~/app/components/LanguageSwitcher';
import { BreadcrumbTrail } from '~/app/landing/Breadcrumb';
import type { CurrentUser } from '@evimo/types';

const { Text } = Typography;

type LandingTopHeaderProps = {
  user: CurrentUser;
  initials: string;
  accountMenu: MenuProps['items'];
  headerHeight: number;
};

export function LandingTopHeader({
  user,
  initials,
  accountMenu,
  headerHeight,
}: LandingTopHeaderProps) {
  return (
    <header className="landing-top-header" style={{ height: headerHeight }}>
      <nav className="landing-top-header__breadcrumb" aria-label="Breadcrumb">
        <BreadcrumbTrail />
      </nav>

      <Space size={12} align="center" className="landing-top-header__actions">
        <LanguageSwitcherContainer withinMenu={false} />
        <Dropdown
          menu={{ items: accountMenu }}
          trigger={['click']}
          overlayClassName="evimo-shell-dropdown"
        >
          <button
            type="button"
            className="evimo-shell-user landing-top-header__account"
            aria-label="Account menu"
          >
            <Flex vertical align="flex-end" className="evimo-shell-user__text">
              <Text strong className="evimo-shell-user__name">
                {user.name ?? user.email}
              </Text>
              <Text type="secondary" className="evimo-shell-user__meta">
                {user.roleName}
              </Text>
            </Flex>
            <Avatar size={32} className="evimo-shell-avatar">
              {initials}
            </Avatar>
          </button>
        </Dropdown>
      </Space>
    </header>
  );
}
